import React, { useContext, useState, useEffect } from 'react'
// CONTEXT 
import { AppContext } from '../../../App'
// USE FIREBASE
import useFirebase from '../../../firebase/useFirebase'
import useForm from '../../../hooks/useForm'
import useAuthFirebase from '../../../firebase/useAuthFirebase'
// COMPONENTS
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
import useHomeUsers from './../../../hooks/users/useHomeUsers'
import useHomeUsersPlanning from './../../../hooks/users/useHomeUsersPlanning'
import usePush from './../../../hooks/usePush'
import Spinner from './../../../components.js/elements/Spinner'
import ModalChoiceStaffUsers from './../../../components.js/users/homeUsers/ModalChoiceStaffUsers'
import ModalCreateAccount from './../../../components.js/users/homeUsers/ModalCreateAccount'
import ModalConnect from './../../../components.js/users/homeUsers/ModalConnect'
import ServicesHomeUsers from './../../../components.js/users/homeUsers/ServicesHomeUsers'
import ChoiceServiceUsers from './../../../components.js/users/homeUsers/ChoiceServiceUsers'
import PlanningUsers from './../../../components.js/users/homeUsers/PlanningUsers'
import IdentificationUser from './../../../components.js/users/homeUsers/IdentificationUser'
import BookingToCome from './../../../components.js/users/homeUsers/BookingToCome'

const INITIAL_STATE = {  
    idService:'', 
    nameService:'',
    priceService:'',
    durationService:'',
    idStaff:'',
    surnameStaff:'',
    nameStaff:'',
    surname:'',
    name:'',
    email:'',
    password:'',
    phone:'',
    hours:'',
}

const BookingUsersPage = () => {
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const { user } = useContext(AppContext) 
    const [montage, setMontage] = useState(false) 
    const [prestation, setPrestation] = useState(false)
    const { _choiceService, valuesService, _choiceStaff, _deleteState, _choiceHours, _updateHours } = useHomeUsers(INITIAL_STATE) 
    const { _converteTimeToHours, _displayHours, _displayStaff, _display60Days } = useHomeUsersPlanning(valuesService) 
    const { handleChange, values } = useForm(INITIAL_STATE) 
    const { _signIn, _forgotPassword, _signUp } = useAuthFirebase() 
    const { updateData, readData, writeData, readDataMessagesChat, profil, services, staff, clients, booking, datesOff, count, messagesChat } = useFirebase() 
    const { _sendPushClientBooking } = usePush() 

    useEffect(() => {
        readData(keyUid) 
        readDataMessagesChat(keyUid) 
        // updateData()
        _writeToken()
    },[montage])

    if (montage === null) return <Spinner /> 

    const _confirmBooking = (uid,id,surname,name,email,token) => {
        const data = {
            date:valuesService.date,
            dateShow:valuesService.dateShow,
            hours:valuesService.hours,
            idStaff:valuesService.idStaff,
            surnameStaff:valuesService.surnameStaff,
            nameStaff:valuesService.nameStaff,
            idService:valuesService.idService,
            nameService:valuesService.nameService,
            durationService:valuesService.durationService,
            priceService:valuesService.priceService,
            uidClient:uid,
            idClient:id,
            surnameClient:surname,
            nameClient:name,
            emailClient:email, 
            token,token
        }
        writeData('entreprises/'+keyUid+'/booking',data)
        let title = profil.filter(p => p.nomEntreprise).map(p => p.nomEntreprise)
        let titleString = new String(title)
        let message = "Bonjour, vous avez rendez-vous aujourd'hui à "+ _converteTimeToHours(valuesService.hours)
        _sendPushClientBooking(valuesService.date,token,titleString,message)
        _deleteState()
        // console.log('HomeUsers _confirmBooking ', token, valuesService.date, _converteTimeToHours(valuesService.hours) /*token, valuesService.date, valuesService.dateShow*/)
    }

    // ENREGISTRER LE TOKEN DANS LA DATABASE
    const _writeToken = () => {
        const data = {[tokenUser]:tokenUser}
        updateData('entreprises/'+keyUid+'/tokens', data)
    } 

    return (
        <div className='container-fluid'>

            {/* HEADER RETOUR */}
            <HeaderReturn title='Services / Réserver' link={'/homeUser/'+keyUid+'/'+tokenUser}/> 

            {/* BOOKING TO COM */}
            <BookingToCome 
                user={user}
                booking={booking}
                _converteTimeToHours={_converteTimeToHours}
            /> 

            {prestation === false ?  
            <>
                {/* AFFICHAGE DES LISTES ET SOUS-LISTES DE SERVICES */}
                <ServicesHomeUsers 
                    services={services} 
                    setPrestation={setPrestation} 
                    _choiceService={_choiceService} 
                /> 
            </>
            : 
            <>

                {/* SERVICE CHOISIT AVEC BOUTTON 'CHOISIR AVEC QUI' */}
                <ChoiceServiceUsers  
                    valuesService={valuesService} 
                    _deleteState={_deleteState} 
                    setPrestation={setPrestation}
                /> 

                {/* AFFICHAGE DU PLANNING AVEC LES JOURS ET HORAIRES DISPONIBLES A LA RESERVATION */}
                <PlanningUsers 
                    valuesService={valuesService} 
                    booking={booking}
                    staff={staff} 
                    datesOff={datesOff}
                    services={services}
                    _display60Days={_display60Days}
                    _displayStaff={_displayStaff}
                    _displayHours={_displayHours}
                    _converteTimeToHours={_converteTimeToHours}
                    _choiceHours={_choiceHours}
                    _updateHours={_updateHours}
                /> 

                {/* AFFICHER IDENTIFICATION */}
                <IdentificationUser 
                    valuesService={valuesService}
                    user={user}
                    keyUid={keyUid}
                    clients={clients}
                    _confirmBooking={_confirmBooking}
                /> 
            </>
            } 

            {/* MODAL QUI AFFICHE LA LISTE DU STAFF A CHOISIR */}
            <ModalChoiceStaffUsers 
                staff={staff}
                services={services}
                valuesService={valuesService}
                _choiceStaff={_choiceStaff}
            /> 

            {/* MODAL CREATE ACCOUNT */}
            <ModalCreateAccount 
                handleChange={handleChange}
                values={values}
                keyUid={keyUid}
                _signUp={_signUp}
                token={tokenUser}
            /> 

            {/* MODAL CONNECT */}
            <ModalConnect 
                handleChange={handleChange}
                values={values}
                _signIn={_signIn}
                _forgotPassword={_forgotPassword}
            /> 

        </div>
    )
}

export default BookingUsersPage